/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsCheckSettingsActivity model module.
 * @module model/EmailsCheckSettingsActivity
 * @version 1.0.0
 */
export class EmailsCheckSettingsActivity {
  /**
   * Constructs a new <code>EmailsCheckSettingsActivity</code>.
   * @alias module:model/EmailsCheckSettingsActivity
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsCheckSettingsActivity</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsCheckSettingsActivity} obj Optional instance to populate.
   * @return {module:model/EmailsCheckSettingsActivity} The populated <code>EmailsCheckSettingsActivity</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsCheckSettingsActivity();
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('force'))
        obj.force = ApiClient.convertToType(data['force'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} enabled
 */
EmailsCheckSettingsActivity.prototype.enabled = undefined;

/**
 * @member {Boolean} force
 */
EmailsCheckSettingsActivity.prototype.force = undefined;

